import React from "react";
import {render} from "react-dom";
import Workbench from "./components/workbench";

let content = document.getElementById("pacotes-root");

render(
  <Workbench
    hideUI={true}
    initialBundles={window.__BrandBundles}
    resume={content.classList.contains("pack-resume") ? true : false}
  />,
  content
);
